export default __webpack_public_path__ + "91071ac85d9cf3cfaf6620f66bd41a45.png";